import React from 'react';
import { Box, Text, Tooltip } from '@podiumhq/design-system';

import { textDashedUnderlineStyles, toolTipStyles } from '../styles';

const BundleFeatureTitle = ({
  hoverLabel,
  title,
  titleStyles = baseTextStyles,
  tooltipTitleStyles = textDashedUnderlineStyles,
}) =>
  hoverLabel ? (
    <Tooltip label={hoverLabel} {...toolTipStyles}>
      <Box>
        <Text {...tooltipTitleStyles}>{title}</Text>
      </Box>
    </Tooltip>
  ) : (
    <Text {...titleStyles}>{title}</Text>
  );

const baseTextStyles = { fontSize: 'md', fontWeight: 'normal' };

export default BundleFeatureTitle;
